import React from "react";
import "./Timeline.css";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FcTimeline } from "react-icons/fc";
import WorkIcon from "@material-ui/icons/Work";
import SchoolIcon from "@material-ui/icons/School";
import StarRateIcon from "@material-ui/icons/StarRate";
import { ThemeContext } from "../../Context/theme";

export const Timeline = () => {
  const [{ themename }] = React.useContext(ThemeContext);
  const [linecolor, setlinecolor] = React.useState(
    themename === "light" ? "#23283e" : "#fcfcfc"
  );

  React.useEffect(() => {
    if (themename === "dark") {
      setlinecolor("#fcfcfc");
    } else {
      setlinecolor("#23283e");
    }
  }, [themename]);
  return (
    <>
      <div className="section mainsection">

        <h2 className="section__title" data-aos="fade-right">
          My <span className="different">Timeline </span>

          <span><FcTimeline /></span>
        </h2>

        <VerticalTimeline lineColor={linecolor} animate={true}  >

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"Aug 2022 - Jan 2024"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
            }}
            contentArrowStyle={{
              borderRight: "16px solid  var(--clr-primary)",
            }}
            visible={true}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<WorkIcon />}
          >
          <div className="text__container">
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Associate at PwC
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Acceleration Center,Bangalore
            </h4>
            

            <p data-aos="fade-right">
            <span className="different">
              Responsibilites Handled:
            </span>
            </p>
            
            <ul data-aos="fade-right" className="responsibility__list">
              <li>Collaborated closely with web designers, project managers, and frontend developers to gather requirements 
              and developed visually appealing and interactive reusable ReactJS components for internal proprietary CMS 
              solution. </li>
              <li>Utilized backend development with Node.js and Express.js for engineering Restful API endpoints to enhance 
application functionality and data exchange efficiency between the client-side and server-side components.
</li>
              <li>Leveraged database technologies, such as Oracle SQL database, to design and optimize data schemas for efficient 
data storage and achieved a 40% increase in data retrieval speed using conditional joins and eliminating cartesian 
product.</li>
              <li>Pull request and migration request of codes from dev environment to test to production</li>
            </ul>
          </div>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"March 2022 - Aug 2022"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
            }}
            contentArrowStyle={{
              borderRight: "16px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<WorkIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-left"
            >
              Intern at PwC 
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-left"
            >
              Acceleration Center,Bangalore
            </h4>
            
              
            <p data-aos="fade-left">
            <span className="different">
              Responsibilites Handled:
            </span>
            </p>
            
            <ul data-aos="fade-left" className="responsibility__list">
              <li>Participated in Agile development methodologies, attending daily stand-ups and sprint planning to gather
              business requirements and translate them into technical requirements and adherence to best practices. </li>
              <li>Performed comprehensive testing, including unit testing and API integration testing, to identify and resolve any 
software defects or functional issues. Utilized debugging tools and techniques to troubleshoot and resolve issues in 
a timely manner, ensuring the delivery of high-quality, bug-free application components.</li>
            </ul>
            
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"Aug 2018 - July 2022"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
            }}
            contentArrowStyle={{
              borderRight: "16px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Student [BTech. in CSE]
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              <a href="https://cgu-odisha.ac.in/"
                 target="_blank"
              >
                C. V. Raman Global University, Bhubaneswar, Odisha.
              </a>
            </h4>
            <p data-aos="fade-right">
              Enrolled in B.Tech Computer Science Engineering(CSE), a four-year undergraduate degree program
              that covered topics such as programming languages, data structures & algorithms, database management systems, operating systems, computer networks.  
              
              Secured first division obtaining <span className="different">8.32 CGPA</span>
            </p>
          </VerticalTimelineElement>
          
          {/* <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"May 2016"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
            }}
            contentArrowStyle={{
              borderRight: "16px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-left"
            >
              Student [+2(Science)]
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-left"
            >
              Stewart Sc. College, Cuttack, Odisha
            </h4>
            <p data-aos="fade-left">
              Pursued 12<sup>th</sup> Science[CHSE] and fetched <span className="different">68.83 Percentage.</span>
            </p>
          </VerticalTimelineElement> */}
          
          {/* <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date={"May 2014"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              border: "3px solid var(--clr-primary)",
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
            }}
            contentArrowStyle={{
              borderRight: "16px solid  var(--clr-primary)",
            }}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
            icon={<SchoolIcon />}
          >
            
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Student [10<sup>th</sup> (CBSE)]
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              D.A.V Public School, CDA, Sector-6, Odisha
            </h4>
            <p data-aos="fade-right">
              Passed CBSE 10<sup>th</sup> board exam obtaining<br/>
              <span className="different">9.0 CGPA</span> 
            </p>
          </VerticalTimelineElement>         */}
          
          <VerticalTimelineElement
            icon={<StarRateIcon />}
            iconStyle={{
              border: ` 3px solid var(--clr-primary)`,
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`,
            }}
          ></VerticalTimelineElement>
        </VerticalTimeline>

      </div>
    </>
  );
};
